import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatDialog, MatPaginator, MatSort, Sort } from '@angular/material';
import { WebConstants } from 'src/app/util/web.constants';
import { ToastrService } from 'ngx-toastr';
import { TokenStorage } from 'src/app/util/token.storage';
import { PaymentDetailSearchService } from 'src/app/services/payment-detail-search';
import { first } from 'rxjs/operators';
import { ExcelExportDataService } from 'src/app/excelService/excel-export-data.service';

@Component({
  selector: 'app-payment-detail-search',
  templateUrl: './payment-detail-search.component.html',
  styleUrls: ['./payment-detail-search.component.scss']
})
export class PaymentDetailSearchComponent implements OnInit {

  public dataSource = new MatTableDataSource();
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  public displayedColumns: string[] = [
    'data.licensePlate',
    'data.zone',
    'data.startTime',
    'data.endTime',
    'data.paymentServiceName',
    'data.source'
  ];

  public licensePlateData: any;
  public gatewayData: any;
  public paymentApiData: any;
  public title: string = WebConstants.MENU_NAMES.LICENSE_PLATE_SEARCH;
  public search: any = "";

  constructor(
    public toastrService: ToastrService,
    public paymentDetailService: PaymentDetailSearchService,
    public excelExportDataService: ExcelExportDataService
  ) { }

  ngOnInit() {
    console.log("PLATE LOOKUP");
  }

  getProperty = (obj, path) => (
    path.split('.').reduce((o, p) => o && o[p], obj)
  )

  findGatewayDataDetailByLP(licensePlate: any){
    this.paymentDetailService.getGatewayDataDetailByLP(licensePlate.toUpperCase()).pipe(first()).subscribe(response => {
     if(response && response.code == WebConstants.STATUS.CODE_SUCCESS){
      this.gatewayData = response.data.filter(x=>x.data.type != "parking");

      for(let i=0; i<this.gatewayData.length; i++){
        this.gatewayData[i].data.source = "Local"
      }

      this.dataSource = new MatTableDataSource<unknown>(this.gatewayData);
      this.dataSource.sortingDataAccessor = (obj, property) => this.getProperty(obj, property);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;

      this.findPaymentApiDataByLP(licensePlate)
     } 
     else{
      this.toastrService.error(response.value, "Failed To Load Data!")
     }
    });
  }

  findPaymentApiDataByLP(licensePlate: any){
    this.paymentDetailService.getPaymentDetailByLPFromApi(licensePlate.toUpperCase()).pipe(first()).subscribe(response => {
     if(response && response.code == WebConstants.STATUS.CODE_SUCCESS){
      this.paymentApiData = response.data;

      for(let i=0; i<this.paymentApiData.length; i++){
        this.paymentApiData[i].source = "Live"
      }

      this.mergeGatewayData();
     } 
     else{
      this.toastrService.error(response.value, "Failed To Load Data!")
     }
    });
  }

  mergeGatewayData(){
    let payData = [];
    let objpay = {"data":null};

    for(let i=0; i<this.paymentApiData.length; i++){
      objpay.data = this.paymentApiData[i];
      payData.push(objpay);
    }

    this.paymentApiData = payData;

    this.licensePlateData = this.gatewayData.concat(this.paymentApiData);
    this.dataSource = new MatTableDataSource<unknown>(this.licensePlateData);
    this.dataSource.sortingDataAccessor = (obj, property) => this.getProperty(obj, property);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;    
  }

  excelSheetDownload() {
    let dataForExcel = [];

    this.licensePlateData.forEach((row: any) => {
      //console.log(row);
      let rowData: any = [
        row.data.numberPlate==null? row.data.lpn:row.data.numberPlate,
        row.data.zoneName==null? row.data.zoneNumber:row.data.zoneName,
        new Date(row.data.startTime).toLocaleString(),
        new Date(row.data.endTime).toLocaleString(),
        row.data.paymentServiceName
      ]
      dataForExcel.push(rowData);
    });

    let reportData = {
      title: this.title,
      data: dataForExcel,
      headers: ['License Plate', 'Zone', 'Start Time','End Time','Payment Service Provider']
    };

    this.excelExportDataService.exportExcel(reportData)
  }

}
